function addPostfixForObjectKeys<T extends { [key: string]: any }>(obj: T, postfix: string) {
  const resObj: { [key: string]: any } = {};

  for (const key in obj) {
    resObj[key + "-" + postfix] = obj[key];
  }

  return resObj;
}

export default addPostfixForObjectKeys;
